module.exports = __webpack_public_path__ + "img/ic_32_workout_item_intensity-low.ea863314.svg";